import { Center, Container } from '@mantine/core';
import { Outlet } from '@tanstack/react-router';
import { useAppStore } from '#shared/hooks';
import { Footer, ReCaptchaProvider } from '#shared/modules/google-recaptcha';

const AuthLayout = () => {
  const isExt = useAppStore(state => state.isExt);

  if (isExt) {
    return (
      <Center h="100vh">
        <Outlet />
      </Center>
    );
  }

  return (
    <ReCaptchaProvider>
      <Container h="100vh" py={80} size={400} strategy="grid">
        <Outlet />
        <Footer />
      </Container>
    </ReCaptchaProvider>
  );
};

export default AuthLayout;
